module.exports = __webpack_public_path__ + "static/zach-dullah-89e3188f4f4a0bb92e8048655609eb04.jpg";